// mui
import { Box, Divider } from '@mui/material';

// libraries
import Moment from 'moment';

// components
import { Flexbox } from '../../../../../../components/layout/Flexbox';

// utils
import { PolicyDrawerTypography as Typography } from '../policy-details.utils';
import { useCowbellTranslations } from '../../../../../../i18n/translations';
import type { PolicyTableInfoDto } from '../../../../../../types/policy/tables/policy-table-info.dto';
import { REDACTED_FIELD } from '../../../../../../config/logrocket';

interface Props {
  policy: PolicyTableInfoDto;
}

export const PreviousAgentInfo = ({ policy }: Props) => {
  const { t } = useCowbellTranslations();

  // Only show if there's a processed BOR (meaning agent has changed)
  if (!policy.isBOR || !policy.brokerOfRecord) {
    return null;
  }

  // Format the BOR date
  const borDateString = policy.brokerOfRecord.created
    ? Moment.utc(policy.brokerOfRecord.created).format('M/D/YYYY hh:mm A')
    : '-';

  return (
    <>
      <Divider style={{ width: '100%', margin: '1rem 0 0.5rem 0' }} />
      <Box>
        <Typography variant="subtitle2" color="primary">
          PREVIOUS {t('agent').toUpperCase()} INFO
        </Typography>
      </Box>
      <Divider style={{ width: '100%', margin: '0.5rem 0 1rem 0' }} />
      <Box display="flex">
        <Box width="100%">
          <Flexbox>
            <Typography>Previous {t('agency')}</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{policy.agencyName}</Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Previous {t('agent')} Name</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{`${policy.agentFirstName} ${policy.agentLastName}`}</Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>Previous {t('agent')} Email</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography
                component="a"
                href={`mailto:${policy.agentEmail}`}
                className="link-underlined--hover"
              >
                {policy.agentEmail}
              </Typography>
            </Box>
          </Flexbox>
          <Flexbox>
            <Typography>BOR Date</Typography>
            <Box className={REDACTED_FIELD}>
              <Typography>{borDateString}</Typography>
            </Box>
          </Flexbox>
        </Box>
      </Box>
    </>
  );
};
